import axios from "axios";

const API = "https://vortexnetowrknew.co.uk/php-backend"; // change if needed

export const getPosts = () => axios.get(`${API}/getPosts.php`);
export const getPost = (id) => axios.get(`${API}/getPost.php?id=${id}`);
export const createPost = (data) => axios.post(`${API}/createPost.php`, data);